import { Grow } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import moment from "moment";
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import {
  getBreakDownReasonGroup,
  getPoolList,
  getBreakDownTableArea,
  resetBreakDownListTable,
} from "../../store/actions/BreakDownListTableActions";
import {
  getUnPlannedMaintenanceListMultiple,
  downloadExcelFile,
} from "../../store/actions/breakDownTasksActions";
import { getShifts } from "../../store/actions/ShiftActions";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import { convertedColumnName, getTableColumns } from "../../common";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

import { getEquipmentReportList } from "../../store/actions/EquipmentAction";
import { getBreakdownRootCauseData } from "../../store/actions/MachineMaintenanceSummaryListActions";

const ssGrd = sessionStorage;

//set current date
const setCurrentDate = (date) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var modifiedMonth = month <= 9 ? "0" + month : month;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var newStartDate = year + "-" + modifiedMonth + "-" + day;
  return newStartDate;
};

const GetFirstDayOfMonth = () => {
  var dt = new Date(); // current date of week
  return new Date(dt.getFullYear(), dt.getMonth(), 1);
};

const GetLastDayOfMonth = () => {
  var curr = new Date(); // get current date
  return new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
};

const GetFirstDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff));
};

const GetLastDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff + 6));
};

function BreakdownListTable() {
  const initialState = {
    checkedMe: false,
    poolIds: ls.get("blt_poolId") || [],
    shiftIds: ls.get("blt_shiftNo") || [],
    status: ls.get("blt_status") || [1, 2],
    callNote: sessionStorage.getItem("blt_callNote") || null,
    user: parseInt(sessionStorage.getItem("blt_user"), 10) || null,
    userName: sessionStorage.getItem("blt_userName") || null,
    breakdownReasonGroup:
      JSON.parse(sessionStorage.getItem("blt_breakdownReasonGroup")) || [],
    breakdownEffect:
      JSON.parse(sessionStorage.getItem("blt_breakdownEffect")) || [],
    breakdownRootCauseIds:
      JSON.parse(sessionStorage.getItem("blt_breakdownRootCauseIds")) || [],
    creatorName: sessionStorage.getItem("blt_creatorName") || null,
    taskId: parseInt(sessionStorage.getItem("blt_taskID")) || 0,
    maintenanceNote: sessionStorage.getItem("blt_maintenanceNote") || null,
    areaGroupCode: sessionStorage.getItem("blt_areaGroupCode") || null,
    selectedCostCenterId:
      JSON.parse(sessionStorage.getItem("blt_selectedCostCenterId")) || [],
    selectedMaintenanceOrderId:
      sessionStorage.getItem("blt_selectedMaintenanceOrderId") || null,
    selectedAreaFilter: sessionStorage.getItem("blt_selectedAreaGroupIds")
      ? JSON.parse(sessionStorage.getItem("blt_selectedAreaGroupIds"))
      : [],
    selectedEquipmentGroup:
      JSON.parse(sessionStorage.getItem("blt_selectedEquipmentGroup")) || [],
    startDate:
      sessionStorage.getItem("blt_startDate") ||
      GetFirstDayOfMonth().toISOString(),
    endDate:
      sessionStorage.getItem("blt_endDate") ||
      GetFirstDayOfMonth().toISOString(),
    nonReportingTimeMin: sessionStorage.getItem("blt_ofTheReportMin") || null,
    totalDurationGreaterThan: sessionStorage.getItem("blt_totalTime") || 0,
    hasOrderPlaced: sessionStorage.getItem("blt_hasOrderPlaced") || null,
  };

  const [filterOpen, setFilterOpen] = useState(false);
  const [breakdownReasonGroupData, setBreakdownReasonGroupData] = useState([]);
  const [breakdownEffectData, setBreakdownEffectData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [costCenterData, setCostCenterData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [rows, setRows] = useState([]);
  const [poolData, setPoolData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [selectedStatusName, setSelectedStatusName] = useState([]);
  const [state, setState] = useState({ ...initialState });
  const [excelFilterState, setExcelFilterState] = useState({});
  const [areaData, setAreaData] = useState([]);
  const [breakdownRootCauseDataF, setBreakdownRootCauseDataF] = useState([]);

  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const history = useHistory();

  let [timeIntervals, setTimeIntervals] = useState([
    { id: 1, name: t("Today") },
    { id: 2, name: t("ThisWeek") },
    { id: 3, name: t("ThisMonth") },
    { id: 4, name: t("Manual") },
  ]);
  let [selectedTimeInterval, setSelectedTimeInterval] = useState(
    ls.get("blt_interval") || 3
  );

  const isMounted = useRef(false);

  const { breakDownListTable, breakDownTask } = useSelector(
    (breakDownState) => breakDownState
  );
  const { breakdownRootCauseData } = useSelector(
    ({ MachineMaintenanceSummaryList }) => MachineMaintenanceSummaryList
  );

  const { shiftList } = useSelector(({ Shifts }) => Shifts);

  useEffect(() => {
    if (breakDownListTable.reasonGroupData.length) {
      setBreakdownReasonGroupData(
        Object.values(breakDownListTable.reasonGroupData)
      );
    }
    if (breakDownListTable.effectList.length) {
      setBreakdownEffectData(Object.values(breakDownListTable.effectList));
    }
    if (breakDownListTable.techList.length) {
      setUserData(Object.values(breakDownListTable.techList));
    }
    if (breakDownListTable.costCenter.length) {
      setCostCenterData(Object.values(breakDownListTable.costCenter));
    }
    if (breakDownListTable.statusList.length && !statusData.length) {
      LoadAreaData();
      setStatusData(Object.values(breakDownListTable.statusList));
      HandleStatusName(
        Object.values(breakDownListTable.statusList),
        state.status
      );
    }
    if (breakDownListTable.poolList.length) {
      setPoolData(Object.values(breakDownListTable.poolList));
    }
  }, [breakDownListTable]);

  const [rowsLength, setRowsLength] = useState(0);

  useEffect(() => {
    if (breakDownTask.unPlannedMaintenance?.firstCallRes) {
      if (state.status.length === 0) {
        setRows([]);
      }
      setRows(
        Object.values(
          breakDownTask.unPlannedMaintenance.firstCallRes.resultObject.content
        )
      );
      setRowsLength(
        breakDownTask.unPlannedMaintenance.firstCallRes.resultObject.totalCount
      );
    }
  }, [breakDownTask.unPlannedMaintenance]);

  useEffect(() => {
    if (breakDownListTable.areaList) {
      if (breakDownListTable.areaList.resultObject) {
        setAreaData(breakDownListTable.areaList.resultObject);
      }
    }
  }, [breakDownListTable.areaList]);

  //Equipment report filter
  let [allGroup, setAllGroup] = useState([]);
  const { eqReportList } = useSelector(({ equipment }) => equipment);
  useEffect(() => {
    if (eqReportList?.resultObject) {
      setAllGroup(
        Object.values(eqReportList.resultObject).map((item, index) => ({
          label: item.name,
          value: item.id,
          name: item.name,
        }))
      );
    }
  }, [eqReportList]);

  //load shift data
  let [shiftData, setShiftData] = useState([]);
  useEffect(() => {
    if (shiftList?.resultObject?.length > 0) {
      setShiftData(shiftList.resultObject[0].shifts);
    }
  }, [shiftList]);

  useEffect(() => {
    setBreakdownRootCauseDataF(breakdownRootCauseData);
  }, [breakdownRootCauseData]);

  // Pagination
  const HandleChangePage = (event) => {
    setRows([]);
    setCurrentPage(event);
    loadDataHandler(event);
  };

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(event);
    sessionStorage.setItem("blt_rowsPerPage", event);
    setCurrentPage(0);
    loadDataHandler(0, event);
  };

  const [sortModel, setSortModel] = useState(() => {
    const saved = localStorage.getItem("breakdownListSort");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    if (isMounted.current) LoadHandler();
    else isMounted.current = true;
  }, [sortModel]);

  useEffect(() => {
    componentDidMount();
    dispatch(getBreakDownReasonGroup());
    dispatch(getBreakdownRootCauseData());
    LoadHandler();
    dispatch(resetBreakDownListTable());
  }, []);

  const componentDidMount = () => {
    setState({
      ...initialState,
    });
  };

  const LoadHandler = () => {
    dispatch(getPoolList({ shouldFireStatus: true })); // GetPoolList and GetStatusList
    dispatch(getEquipmentReportList());
    let lastRowsPerPage = rowsPerPage;
    if (sessionStorage.getItem("blt_rowsPerPage")) {
      lastRowsPerPage = parseInt(sessionStorage.getItem("blt_rowsPerPage"));
      setRowsPerPage(lastRowsPerPage);
    }
    if (sessionStorage.getItem("blt_pushBreakdownDetail")) {
      setCurrentPage(
        parseInt(sessionStorage.getItem("blt_pushBreakdownDetail"))
      );
      loadDataHandler(
        parseInt(sessionStorage.getItem("blt_pushBreakdownDetail")),
        lastRowsPerPage
      );
      sessionStorage.removeItem("blt_pushBreakdownDetail");
    } else {
      loadDataHandler(0, lastRowsPerPage);
    }
    dispatch(getShifts());
  };

  // Load data handler
  const loadDataHandler = (
    pageNumber = currentPage,
    pageSize = rowsPerPage,
    isFilterCleared = false
  ) => {
    var ss = sessionStorage;

    const machineId = isFilterCleared
      ? 0
      : machineStates.selectedSubEquipmentCode ??
      machineStates.selectedMainEquipmentCode ??
      0;

    const data = {
      statusArr: ls.get("blt_status")
        ? ls.get("blt_status").toString()
        : [1, 2].toString(),
      poolIds: ls.get("blt_poolId") || [],
      assigneedIds: ss.getItem("blt_user")
        ? [parseInt(ss.getItem("blt_user"))]
        : [],
      creatorIds: ss.getItem("blt_creatorCode")
        ? [parseInt(ss.getItem("blt_creatorCode"))]
        : [],
      breakdownEffectIds: ss.getItem("blt_breakdownEffect")
        ? JSON.parse(ss.getItem("blt_breakdownEffect"))
        : [],
      breakdownGroupIds: ss.getItem("blt_breakdownReasonGroup")
        ? JSON.parse(ss.getItem("blt_breakdownReasonGroup"))
        : [],
      breakdownRootCauseIds: ss.getItem("blt_breakdownRootCauseIds")
        ? JSON.parse(ss.getItem("blt_breakdownRootCauseIds"))
        : [],
      costCenterIds: ss.getItem("blt_selectedCostCenterId")
        ? JSON.parse(ss.getItem("blt_selectedCostCenterId"))
        : [],
      areaGroupIds: ss.getItem("blt_selectedAreaGroupIds")
        ? JSON.parse(ss.getItem("blt_selectedAreaGroupIds"))
        : [],
      equipmentReportGroupIds: ss.getItem("blt_selectedEquipmentGroup")
        ? JSON.parse(ss.getItem("blt_selectedEquipmentGroup"))
        : [],
      taskId: ss.getItem("blt_taskID") ? parseInt(ss.getItem("blt_taskID")) : 0,
      orderId: ss.getItem("blt_selectedMaintenanceOrderId")
        ? parseInt(ss.getItem("blt_selectedMaintenanceOrderId"))
        : 0,
      taskNote: ss.getItem("blt_maintenanceNote")
        ? ss.getItem("blt_maintenanceNote")
        : null,
      orderNote: ss.getItem("blt_callNote") ? ss.getItem("blt_callNote") : null,
      machineId: machineId,
      startDate: ss.getItem("blt_startDate")
        ? ss.getItem("blt_startDate")
        : GetFirstDayOfMonth().toISOString(),
      endDate: ss.getItem("blt_endDate")
        ? ss.getItem("blt_endDate")
        : GetLastDayOfMonth().toISOString(),
      isEnvNotClean: JSON.parse(ss.getItem("blt_isEnvNotClean")),
      hasOrderPlaced: JSON.parse(ss.getItem("blt_hasOrderPlaced")),
      shifts: ls.get("blt_shiftNo") || [],
      totalDurationGreaterThan: ss.getItem("blt_totalTime")
        ? parseInt(ss.getItem("blt_totalTime"))
        : 0,
    };

    setExcelFilterState(data);

    let payload = {
      pageSize: pageSize,
      currentPage: pageNumber + 1,
      data: {
        ...data,
        sortModel,
      },
      firstCall: true,
    };

    dispatch(getUnPlannedMaintenanceListMultiple(payload));
  };

  // Set status
  const HandleStatus = (event) => {
    setCurrentPage(0); // set the first page to zero when statu is changed.
    setState({ ...state, status: event.target.value });
    HandleStatusName(statusData, event.target.value);
    ls.set("blt_status", event.target.value);
  };

  // Set status name
  const HandleStatusName = (rawArray, filterArray) => {
    const statusFiltered = rawArray.filter((el) => {
      return filterArray.some((f) => {
        return f === el.code;
      });
    });
    setSelectedStatusName(statusFiltered.map((item) => item.description));
  };

  // Set pool
  const HandlePool = (poolName) => {
    setCurrentPage(0);
    let ids = [];
    poolName.map((item) => ids.push(item.id));
    setState({ ...state, poolIds: ids });
    ls.set("blt_poolId", ids);
  };

  // Set breakdown reason group
  const HandleBreakdownReasonGroup = (breakdownReasonGroup) => {
    let ids = [];
    breakdownReasonGroup.map((item) => ids.push(item.id));
    if (breakdownReasonGroup == null) {
      sessionStorage.removeItem("blt_breakdownReasonGroup");
    } else {
      sessionStorage.setItem("blt_breakdownReasonGroup", JSON.stringify(ids));
    }
    setState({ ...state, breakdownReasonGroup: ids });
  };

  // Set breakdown reason group
  const HandleEquipmentGroup = (equipmentGroup) => {
    let ids = [];
    equipmentGroup.map((item) => ids.push(item.value));
    if (equipmentGroup == null) {
      sessionStorage.removeItem("blt_selectedEquipmentGroup");
    } else {
      sessionStorage.setItem("blt_selectedEquipmentGroup", JSON.stringify(ids));
    }
    setState({ ...state, selectedEquipmentGroup: ids });
  };

  const HandleCostCenterChange = (costCenter) => {
    let ids = [];
    costCenter.map((item) => ids.push(item.id));
    if (costCenter == null) {
      sessionStorage.removeItem("blt_selectedCostCenterId");
    } else {
      sessionStorage.setItem("blt_selectedCostCenterId", JSON.stringify(ids));
    }
    setState({ ...state, selectedCostCenterId: ids });
  };

  const HandleAreaFilterChange = (areaName) => {
    console.log("areaName", areaName);
    let areaGroupIds = [];
    areaName.map((item) => areaGroupIds.push(item.id));
    if (areaName == null) {
      sessionStorage.removeItem("blt_selectedAreaGroupIds");
    } else {
      sessionStorage.setItem(
        "blt_selectedAreaGroupIds",
        JSON.stringify(areaGroupIds)
      );
    }
    setState({ ...state, selectedAreaFilter: areaGroupIds });
  };

  const HandleBreakdownEffect = (breakdownEffect) => {
    let ids = [];
    breakdownEffect.map((item) => ids.push(item.id));
    if (breakdownEffect == null) {
      sessionStorage.removeItem("blt_breakdownEffect");
    } else {
      sessionStorage.setItem("blt_breakdownEffect", JSON.stringify(ids));
    }
    setState({ ...state, breakdownEffect: ids });
  };

  // Set user
  const HandleUser = (userName) => {
    const userInfo = userData.filter((item) => item.userName == userName);
    let userId = null;

    if (userInfo[0] != undefined) {
      // Filter if user exist
      userId = userInfo[0].id;
    }
    if (userName == null) {
      sessionStorage.removeItem("blt_userName");
      sessionStorage.removeItem("blt_user");
    } else {
      sessionStorage.setItem("blt_userName", userName);
      sessionStorage.setItem("blt_user", userId);
    }

    setState({ ...state, checkedMe: false, user: userId, userName: userName });
  };

  // Set start date
  const HandleStartDate = (date) => {
    if (date == null) {
      sessionStorage.removeItem("blt_startDate");
    } else {
      sessionStorage.setItem(
        "blt_startDate",
        moment(date).format("YYYY-MM-DD")
      );
    }

    ls.set("blt_interval", 4);
    setSelectedTimeInterval(4);
    setState({ ...state, startDate: date });
  };

  // Set end date
  const HandleEndDate = (date) => {
    if (date == null) {
      sessionStorage.removeItem("blt_endDate");
    } else {
      sessionStorage.setItem("blt_endDate", moment(date).format("YYYY-MM-DD"));
    }

    ls.set("blt_interval", 4);
    setSelectedTimeInterval(4);
    setState({ ...state, endDate: date });
  };

  const HandleTotalTime = (e) => {
    if (e.target.value == null) {
      sessionStorage.removeItem("blt_totalTime");
    } else {
      sessionStorage.setItem("blt_totalTime", e.target.value);
    }

    setState({ ...state, totalTime: e.target.value });
  };

  const HandleApplyFilter = () => {
    toggleDrawer(false);
    breakDownListTable.costCenter = [];
    loadDataHandler(0, rowsPerPage);
    setIsFilterDrawerOpen(false);
  };

  const FilterWithID = (e) => {
    if (e.target.value == null) {
      sessionStorage.removeItem("blt_taskID");
    } else {
      sessionStorage.setItem("blt_taskID", e.target.value);
    }

    setState({ ...state, taskId: e.target.value });
  };

  const FilterWithMaintenanceNote = (e) => {
    if (e.target.value == null) {
      sessionStorage.removeItem("blt_maintenanceNote");
    } else {
      sessionStorage.setItem("blt_maintenanceNote", e.target.value);
    }

    setState({ ...state, maintenanceNote: e.target.value });
  };

  const FilterWithCallNote = (e) => {
    if (e.target.value == null) {
      sessionStorage.removeItem("blt_callNote");
    } else {
      sessionStorage.setItem("blt_callNote", e.target.value);
    }

    setState({ ...state, callNote: e.target.value });
  };

  const FilterOrderId = (e) => {
    if (e.target.value == null) {
      sessionStorage.removeItem("blt_selectedMaintenanceOrderId");
    } else {
      sessionStorage.setItem("blt_selectedMaintenanceOrderId", e.target.value);
    }

    setState({ ...state, selectedMaintenanceOrderId: e.target.value });
  };

  const HandleHasOrderPlaced = (e) => {
    if (e == null) {
      sessionStorage.removeItem("blt_hasOrderPlaced");
    } else {
      sessionStorage.setItem("blt_hasOrderPlaced", e);
    }
    setState({ ...state, hasOrderPlaced: e });
  };

  // Load area data for popup
  const LoadAreaData = () => {
    dispatch(getBreakDownTableArea());
  };

  const setDefaultState = () => {
    setState({
      checkedMe: false,
      poolIds: ls.get("blt_poolId") || [],
      shiftIds: ls.get("blt_shiftNo") || [],
      status: ls.get("blt_status") || [1, 2],
      callNote: null,
      user: null,
      userName: null,
      breakdownReasonGroup: [],
      breakdownEffect: [],
      breakdownRootCauseIds: [],
      creatorName: null,
      taskId: 0,
      maintenanceNote: null,
      areaGroupCode: null,
      selectedCostCenterId: [],
      selectedMaintenanceOrderId: null,
      selectedAreaFilter: [],
      selectedEquipmentGroup: [],
      startDate:
        sessionStorage.getItem("blt_startDate") || setCurrentDate(new Date()),
      endDate:
        sessionStorage.getItem("blt_endDate") || setCurrentDate(new Date()),
      totalDurationGreaterThan: null,
      hasOrderPlaced: null,
    });
  };

  // Set creator for filter
  const HandleCreatorName = (creatorName) => {
    const userInfo = userData.filter((item) => item.userName == creatorName);
    let creatorCode = null;

    if (userInfo[0] != undefined) {
      creatorCode = userInfo[0].id;
    }
    if (creatorName == null) {
      sessionStorage.removeItem("blt_creatorName");
      sessionStorage.removeItem("blt_creatorCode");
    } else {
      sessionStorage.setItem("blt_creatorName", creatorName);
      sessionStorage.setItem("blt_creatorCode", creatorCode);
    }

    setState({
      ...state,
      checkedMe: false,
      creatorName: creatorName,
      creatorCode: creatorCode,
    });
  };

  const initialMachineStates = (isCleared = false) => {
    return {
      ssAbr: "blt",
      selectedAreaCode: isCleared
        ? null
        : ssGrd.getItem("blt_selectedAreaCode") ?? null,
      selectedAreaName: isCleared
        ? null
        : ssGrd.getItem("blt_selectedAreaName") ?? null,
      selectedMainEquipmentCode: isCleared
        ? null
        : ssGrd.getItem("blt_selectedMainEquipmentCode") ?? null,
      selectedMainEquipmentName: isCleared
        ? null
        : ssGrd.getItem("blt_selectedMainEquipmentName") ?? null,
      selectedSubEquipmentCode: isCleared
        ? null
        : ssGrd.getItem("blt_selectedSubEquipmentCode") ?? null,
      selectedSubEquipmentName: isCleared
        ? null
        : ssGrd.getItem("blt_selectedSubEquipmentName") ?? null,
    };
  };
  const [machineStates, setMachineStates] = useState(initialMachineStates);
  const HandleClearMachineStates = () => {
    ssGrd.removeItem("blt_selectedAreaCode");
    ssGrd.removeItem("blt_selectedAreaName");
    ssGrd.removeItem("blt_selectedMainEquipmentCode");
    ssGrd.removeItem("blt_selectedMainEquipmentName");
    ssGrd.removeItem("blt_selectedSubEquipmentCode");
    ssGrd.removeItem("blt_selectedSubEquipmentName");
    setMachineStates(initialMachineStates(true));
  };

  const HandleClearFilter = () => {
    HandleStatusName(statusData, []);
    setSelectedTimeInterval(3);
    ls.set("blt_interval", 3);
    sessionStorage.removeItem(
      "blt_startDate",
      GetFirstDayOfMonth().toISOString()
    );
    sessionStorage.removeItem("blt_endDate", GetLastDayOfMonth().toISOString());
    ls.set("blt_status", []);
    ls.set("blt_poolId", []);
    ls.set("blt_shiftNo", []);

    HandleClearMachineStates();
    setIsEnvNotClean(null);
    handleClearSessionStorage();
    setDefaultState();
    loadDataHandler(0, rowsPerPage, true);
    setFilterOpen(false);
  };

  const handleClearSessionStorage = () => {
    sessionStorage.removeItem("blt_areaGroupCode");
    sessionStorage.removeItem("blt_breakdownEffect");
    sessionStorage.removeItem("blt_breakdownReasonGroup");
    sessionStorage.removeItem("blt_callNote");
    sessionStorage.removeItem("blt_creatorName");
    sessionStorage.removeItem("blt_creatorCode");
    sessionStorage.removeItem("blt_maintenanceNote");
    sessionStorage.removeItem("blt_taskID");
    sessionStorage.removeItem("blt_user");
    sessionStorage.removeItem("blt_userName");
    sessionStorage.removeItem("blt_breakdownRootCauseIds");
    sessionStorage.removeItem("blt_selectedAreaFilter");
    sessionStorage.removeItem("blt_selectedEquipmentGroup");
    sessionStorage.removeItem("blt_selectedAreaGroupIds");
    sessionStorage.removeItem("blt_selectedCostCenterId");
    sessionStorage.removeItem("blt_selectedMaintenanceOrderId");
    sessionStorage.removeItem("blt_startDate");
    sessionStorage.removeItem("blt_endDate");
    sessionStorage.removeItem("blt_isEnvNotClean");
    sessionStorage.removeItem("blt_startDate");
    sessionStorage.removeItem("blt_endDate");
    sessionStorage.removeItem("blt_totalTime");
    sessionStorage.removeItem("blt_hasOrderPlaced");
  };

  const NavigateToDetails = (id) => {
    sessionStorage.setItem("blt_pushBreakdownDetail", currentPage);
    sessionStorage.setItem("blt_rowsPerPage", rowsPerPage);
    history.push("/breakdowndetail?id=" + id);
  };

  const columnVisibilityModelData =
    JSON.parse(localStorage.getItem("columnVisibilityModel")) || {};
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    columnVisibilityModelData
  );

  const customToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarDensitySelector />
        <GridToolbarColumnsButton name="column" />
        {/* <GridToolbarFilterButton /> */}
      </GridToolbarContainer>
    );
  };

  const handleChangeVisibility = (newModel) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem("columnVisibilityModel", JSON.stringify(newModel));
  };

  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsFilterDrawerOpen(open);
  };

  const HandleShift = (shiftNo) => {
    let shiftIds = [];
    if (shiftNo != null) {
      shiftNo.map((item) => shiftIds.push(item.shiftNo));
      setState({ ...state, shiftIds: shiftIds });
      ls.set("blt_shiftNo", shiftIds);
    }
  };

  const SetDates = (start, end) => {
    setState((prevState) => ({
      ...prevState,
      startDate: start,
      endDate: end,
    }));
    sessionStorage.setItem("blt_startDate", start);
    sessionStorage.setItem("blt_endDate", end);
  };

  const HandleTimeSelection = (id) => {
    switch (id) {
      case 1: //gün
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
      case 2: //hafta
        SetDates(
          GetFirstDayOfWeek(new Date()).toISOString(),
          GetLastDayOfWeek(new Date()).toISOString()
        );
        break;
      case 3: //ay
        SetDates(
          GetFirstDayOfMonth().toISOString(),
          GetLastDayOfMonth().toISOString()
        );
        break;
      default:
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
    }
  };

  const HandleTimeInterval = (e) => {
    setSelectedTimeInterval(e.target.value);
    ls.set("blt_interval", e.target.value);
    HandleTimeSelection(e.target.value);
    loadDataHandler(0, rowsPerPage);
  };

  const HandleBreakdownRootCause = (breakdownRootCauseIds) => {
    let ids = [];
    breakdownRootCauseIds.map((item) => ids.push(item.id));
    if (breakdownRootCauseIds == null) {
      sessionStorage.removeItem("blt_breakdownRootCauseIds");
    } else {
      sessionStorage.setItem("blt_breakdownRootCauseIds", JSON.stringify(ids));
    }
    setState({ ...state, breakdownRootCauseIds: ids });
  };

  const filter = () => {
    return (
      <DetailFilter
        HandleStatus={HandleStatus}
        statusData={statusData}
        status={state.status}
        selectedStatusName={selectedStatusName}
        HandlePool={HandlePool}
        poolData={poolData}
        poolIds={state.poolIds}
        HandleUser={HandleUser}
        HandleBreakdownRootCause={HandleBreakdownRootCause}
        HandleCreatorName={HandleCreatorName}
        HandleBreakdownEffect={HandleBreakdownEffect}
        HandleBreakdownReasonGroup={HandleBreakdownReasonGroup}
        HandleCostCenterChange={HandleCostCenterChange}
        HandleAreaFilterChange={HandleAreaFilterChange}
        FilterWithID={FilterWithID}
        FilterOrderId={FilterOrderId}
        FilterWithMaintenanceNote={FilterWithMaintenanceNote}
        FilterWithCallNote={FilterWithCallNote}
        HandleStartDate={HandleStartDate}
        HandleEndDate={HandleEndDate}
        userName={state.userName}
        creatorName={state.creatorName}
        breakdownEffect={state.breakdownEffect}
        breakdownRootCause={state.breakdownRootCauseIds}
        breakdownReasonGroup={state.breakdownReasonGroup}
        breakdownRootCauseData={breakdownRootCauseDataF}
        selectedCostCenterId={state.selectedCostCenterId}
        selectedAreaFilter={state.selectedAreaFilter}
        selectedMaintenanceOrderId={state.selectedMaintenanceOrderId}
        maintenanceNote={state.maintenanceNote}
        taskId={state.taskId}
        callNote={state.callNote}
        startDate={state.startDate}
        maxDate={new Date()}
        endDate={state.endDate}
        userData={userData}
        areaData={areaData}
        costCenterData={costCenterData}
        breakdownEffectData={breakdownEffectData}
        breakdownReasonGroupData={breakdownReasonGroupData}
        setMachineStates={setMachineStates}
        machineStates={machineStates}
        isAreaNotFiltered={true}
        isEnvNotClean={isEnvNotClean}
        handleEnvironmentalComplianceChange={
          handleEnvironmentalComplianceChange
        }
        HandleShift={HandleShift}
        shiftData={shiftData}
        shiftIds={state.shiftIds}
        HandleTimeInterval={HandleTimeInterval}
        selectedTimeInterval={selectedTimeInterval}
        timeIntervals={timeIntervals}
        HandleEquipmentGroup={HandleEquipmentGroup}
        equipmentGroupData={allGroup}
        selectedEquipmentGroup={state.selectedEquipmentGroup}
        HandleTotalTime={HandleTotalTime}
        totalTime={state.totalTime}
        HandleHasOrderPlaced={HandleHasOrderPlaced}
        hasOrderPlaced={state.hasOrderPlaced}
        isMultipleAreaGroup={true}
      />
    );
  };

  const [isEnvNotClean, setIsEnvNotClean] = useState(
    JSON.parse(sessionStorage.getItem("blt_isEnvNotClean"))
  );
  const handleEnvironmentalComplianceChange = (newValue) => {
    setIsEnvNotClean(newValue);
    sessionStorage.setItem("blt_isEnvNotClean", newValue);
  };

  useEffect(() => {
    localStorage.setItem("breakdownListSort", JSON.stringify(sortModel));
  }, [sortModel]);

  const onSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    localStorage.setItem("breakdownListSort", JSON.stringify(newSortModel));
  };


  return (
    <StyledTableDiv>
      <h1 id="blt_PageTitle">{t("BreakdownList")}</h1>
      <FilterDrawer
        open={isFilterDrawerOpen}
        onOpen={toggleDrawer(true)}
        onClose={toggleDrawer(false)}
        HandleClearFilter={HandleClearFilter}
        HandleApplyFilter={HandleApplyFilter}
        downloadExcel={() =>
          dispatch(
            downloadExcelFile({
              ...excelFilterState,
              startDate: excelFilterState.startDate ?? "2021-01-01",
              endDate: excelFilterState.endDate ?? "2023-01-01",
            })
          )
        }
        detailFilter={filter()}
      />
      <FilterButton onClick={() => toggleDrawer(true)} />
      {rows.length ? (
        <Grow
          in={true}
          style={{ transformOrigin: "0 0 0" }}
          {...{ timeout: 1000 }}
        >
          <div style={{ width: "100%", textAlign: "center" }}>
            <DataGrid
              autoHeight={true}
              rows={rows}
              columns={getTableColumns(false, poolData, statusData)}
              pageSize={rowsPerPage}
              onPageSizeChange={HandleChangeRowsPerPage}
              onPageChange={HandleChangePage}
              rowsPerPageOptions={[5, 10, 20, 50]}
              rowCount={rowsLength} //total count
              page={currentPage}
              sortModel={sortModel}
              paginationMode="server"
              disableColumnFilter
              disableColumnMenu
              getRowId={(row) => row.id}
              onRowClick={(param) => {
                NavigateToDetails(param.id);
              }}
              components={{
                Toolbar: customToolbar,
              }}
              filterMode="server"
              // onFilterModelChange={(param) => {
              //     onFilterChange(param, 0, rowsPerPage);
              // }}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) =>
                handleChangeVisibility(newModel)
              }
              onSortModelChange={onSortModelChange}
              sx={{
                boxShadow: 5,
                "& .MuiDataGrid-row:hover": {
                  color: "primary.main",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
              }}
              localeText={{
                toolbarColumns: t("Columns"),
                columnsPanelTextFieldLabel: t("ColumnsPanelTextFieldLabel"),
                columnsPanelTextFieldPlaceholder: t(
                  "ColumnsPanelTextFieldPlaceholder"
                ),
                columnsPanelShowAllButton: t("ColumnsPanelShowAllButton"),
                columnsPanelHideAllButton: t("ColumnsPanelHideAllButton"),
                toolbarDensity: t("Density"),
                toolbarDensityCompact: t("DensityCompact"),
                toolbarDensityStandard: t("DensityStandard"),
                toolbarDensityComfortable: t("DensityComfortable"),
              }}
            />
          </div>
        </Grow>
      ) : null}

      <LoadingBackdrop id="bl_table_ldb" />
    </StyledTableDiv>
  );
}

export default withRouter(BreakdownListTable);
